import { render, staticRenderFns } from "./LeadDetailCard.vue?vue&type=template&id=c6eab1a4&scoped=true"
import script from "./LeadDetailCard.vue?vue&type=script&lang=ts"
export * from "./LeadDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./LeadDetailCard.vue?vue&type=style&index=0&id=c6eab1a4&prod&lang=scss"
import style1 from "./LeadDetailCard.vue?vue&type=style&index=1&id=c6eab1a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6eab1a4",
  null
  
)

export default component.exports